import profile from "../../const/profile";
import netcoServer from '../../apis/netcoServer';
import {UPDATE_PDF_FEATURES} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import getUserInfo from "./getUserInfo";
import loadingCall from "../helpers/loadingCall";
import modalDismiss from "../modal/modalDismiss";
import getValidOperations from "../signature/getValidOperations";

const updatePDFFeatures= (formValues) => async (dispatch, getState) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/UserService/updatePDFFeatures', formValues));
  handleResponse(dispatch, response, UPDATE_PDF_FEATURES, data => onSuccessPayload(data, getState), null, [getUserInfo, modalDismiss, getValidOperations]);
};

const onSuccessPayload = (data, getState) => {
  return infoPayload('success', profile[getState().auth.language].pdfOptionsSaved);
};
export default updatePDFFeatures;